import { render, staticRenderFns } from "./MenuMobile.vue?vue&type=template&id=8c223dec"
import script from "./MenuMobile.vue?vue&type=script&lang=js"
export * from "./MenuMobile.vue?vue&type=script&lang=js"
import style0 from "./MenuMobile.vue?vue&type=style&index=0&id=8c223dec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports